import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import * as searchActions from '../search/search.actions';
import { SoledadSearchService } from '../../../shared/services/b2b/search.service';

@Injectable()
export class SearchEffects {
    constructor(private actions$: Actions, private searchService: SoledadSearchService) {}

    searchProducts$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(
                searchActions.SearchActionTypes.DO_GET_INFO_PRODUCTS,
                searchActions.SearchActionTypes.DO_CANCEL_GET_INFO_PRODUCTS
            ),
            switchMap((action: any) => {
                if (action.type === searchActions.SearchActionTypes.DO_CANCEL_GET_INFO_PRODUCTS) {
                    return of({ type: 'CANCEL_SEARCH' });
                }

                if (action.type === searchActions.SearchActionTypes.DO_GET_INFO_PRODUCTS) {
                    return this.searchService
                        .search(action.payload.user, action.payload.settings, action.payload.searchParams)
                        .pipe(
                            map((data) => {
                                return new searchActions.DoGetInfoProductsOK(data);
                            }),
                            catchError((error) => of(new searchActions.DoGetInfoProductsKO(error)))
                        );
                }

                return of({ type: 'NO_ACTION' }); // Return a default action in case none of the conditions match.
            })
        )
    );
}
